<script setup lang="ts">
import { ref } from 'vue'

import { Button, Popover } from '@collector/shared-ui'
import { useNotifications } from '@desktop/globalState/notifications'

import NotificationsPopoverContent from './NotificationsPopoverContent.vue'

// composables
const { isNotificationVisible } = useNotifications()

// state
const isPopoverOpen = ref(false)
</script>

<template>
  <Popover
    v-model="isPopoverOpen"
    :trigger="{
      asChild: true,
    }"
  >
    <template #trigger>
      <Button
        class="relative"
        :class="{
          'bg-neutral-light-0 border-neutral-light-0': isPopoverOpen,
          'border-neutral-light-7 bg-neutral-light-7 hover:bg-neutral-light-3 hover:border-neutral-light-3':
            !isPopoverOpen,
        }"
        icon="bell"
        size="sm"
        square
      >
        <span
          v-if="isNotificationVisible"
          class="text-2xs bg-error-5 text-neutral-light-10 border-neutral-light-10 absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full border"
        ></span>
      </Button>
    </template>
    <template #content>
      <NotificationsPopoverContent />
    </template>
  </Popover>
</template>
